
import Vue from 'vue'
import NavBarItem  from '@/components/globalHeader/NavBarItem.vue'
import HeaderAccount from '@/components/globalHeader/HeaderAccount.vue'
import HeaderContact from '@/components/HeaderContact.vue'
import HeaderFlag from '@/components/globalHeader/HeaderFlag.vue'
import { CommonData } from '@/types/commonData'
import eventBus from '@/utils/eventBus'
import { APP_EVENTS } from '@/constants'
import FAVORITE_ICON from './../../../../../app/assets/images/web/common//gh-icon-favorite.svg'
import CART_ICON from './../../../../../app/assets/images/web/common//gh-icon-cart.svg'

interface HeaderNavItem {
  icon: string,
  link: string,
  badge?: number,
  cartItem?: boolean
}
export default Vue.extend({
  components: {
    NavBarItem,
    // HeaderSearch,
    HeaderAccount,
    HeaderContact,
    HeaderFlag
  },
  props: {
    orderHistoryCount: {
      type: Number,
      default: 0
    },
    currentUser: {
      validator: v => typeof v === 'object' || v === null,
      required: true
    },
    commonData: {
      type: Object as () => CommonData,
      required: true
    }
  },
  data(): {
    favoritesCount: number,
    toggleRegionModal: boolean
  } {
    return {
      favoritesCount: 0,
      toggleRegionModal: false
    }
  },
  computed: {
    accountLink(): string {
      return `${this.commonData.custa_account_url}`
    },
    loginLink(): string {
      return `${this.accountLink}/sign_in?referral=${window.location}`
    },
    isCustomer(): boolean {
      return this.currentUser != null
    },
    headerNavItems(): HeaderNavItem[]{
      return [
        {
          icon: FAVORITE_ICON,
          link: '/estimate',
          badge: this.favoritesCount
        },
        {
          icon: CART_ICON,
          link: '/cart',
          cartItem: true,
          badge: this.commonData.cart_count
        }
      ]
    }
  },
  created() {
    this.favoritesCount = this.commonData.favorites_count
    eventBus.$on(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, (count: number) => {
      this.favoritesCount = count
    })
  },
  methods: {
    goToLogin(): void {
      window.location.href = this.loginLink
    }
  }
})
